module.exports = __webpack_public_path__ + "img/adas-hil-3.bf79a66f.svg";